<img
  mat-card-avatar
  [src]="avatarLink"
  class="avatar-image"
  alt="Foto do beneficiario"
/>
